module.exports = __webpack_public_path__ + "static/img/coche_logo.2b99501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coche_logo.png
// module id = 252
// module chunks = 1